<!--医师产品订单统计-->
<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top"style="justify-content: space-between;">
                <div>
                    <el-input
                            v-model="query.realName"
                            placeholder="请输入医生姓名"
                            style="width: 200px;margin-right: 20px"
                            suffix-icon="el-icon-search"
                            size="small">
                    </el-input>
                    <el-input
                            v-model="query.nickName"
                            placeholder="请输入业务姓名"
                            suffix-icon="el-icon-search"
                            style="width: 200px;"
                            size="small">
                    </el-input>
                    <el-date-picker
                            v-model="date"
                            type="daterange"
                            align="right"
                            @change="dateChange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                    <el-button type="primary" @click="getData()">搜索</el-button>
                </div>
                <div style="display:flex">
                    <el-button size="small" @click="download" style="width: 96px;float:left">导出</el-button>
                    <el-button size="small"  @click="excelExport" style="width: 96px;float:left">下载模板</el-button>
                    <el-upload
                            style="display: inline-block; margin-left:10px;margin-right:10px;width:96px;float:right;"
                            action=""
                            :multiple="false"
                            :limit=1
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                            :show-file-list="false"
                            :drag="false"
                            :http-request="uploadFile"
                            ref="excel"
                    >
                        <el-button size="small" style="width: 96px;float:left">批量导入</el-button>
                    </el-upload>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          style="width: 100%;margin-bottom: 20px;"
                          border>
                    <el-table-column label="医生id" sortable>
                        <template slot-scope="scope">
                            <div>{{scope.row.id}}</div>
                            <p STYLE="color: #af0000">产品id</p>
                            <div v-for="item in scope.row.list">
                                <p STYLE="color: #66b1ff">{{item.id}}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="医生" sortable>
                        <template slot-scope="scope">
                            <div>{{scope.row.realName}}</div>
                            <p STYLE="color: #af0000">产品名</p>
                            <div v-for="item in scope.row.list">
                                <p STYLE="color: #66b1ff">{{item.realName}}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="业务员" sortable>
                        <template slot-scope="scope">
                            <div>{{scope.row.nickName}}</div>
                            <p STYLE="color: #af0000">产品总金额</p>
                            <div v-for="item in scope.row.list">
                                <p STYLE="color: #66b1ff">{{item.nickName}}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="经理" sortable>
                        <template slot-scope="scope">
                            <div>{{scope.row.topNickName}}</div>
                            <p STYLE="color: #af0000">提成比例</p>
                            <div v-for="item in scope.row.list">
                                <p STYLE="color: #66b1ff" v-if="item.topNickName!=''">{{item.topNickName}}</p>
                                <p STYLE="color: #66b1ff" v-else>暂无</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remitStipulate" label="打款决定"></el-table-column>
                    <el-table-column prop="remake" label="备注"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="update(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="编辑产品金额" :visible.sync="editVisible" width="330px">
            <el-form ref="edit" :model="form" label-width="80px" size="small">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.realName" style="width: 100px" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="打款决定" prop="remitStipulate">
                    <el-input v-model="form.remitStipulate" style="width: 100px"></el-input>
                </el-form-item>
                <el-form-item label="提成比例" prop="topNickName">
                    <el-input v-model="form.topNickName" style="width: 100px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remake">
                    <el-input v-model="form.remake" style="width: 100px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                  <el-button @click="editVisible=false" style="width: 76px">取 消</el-button>
                  <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
              </span>
        </el-dialog>
    </div>
</template>
<script>
    function revertUTF8(szInput) {
        var x,wch,wch1,wch2,uch="",szRet="";
        for (x=0; x<szInput.length; x++) {
            if (szInput.charAt(x)=="%") {
                wch =parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                if (!wch) {break;}
                if (!(wch & 0x80)) {
                    wch = wch;
                } else if (!(wch & 0x20)) {
                    x++;
                    wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                    wch  = (wch & 0x1F)<< 6;
                    wch1 = wch1 & 0x3F;
                    wch  = wch + wch1;
                } else {
                    x++;
                    wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                    x++;
                    wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x),16);
                    wch  = (wch & 0x0F)<< 12;
                    wch1 = (wch1 & 0x3F)<< 6;
                    wch2 = (wch2 & 0x3F);
                    wch  = wch + wch1 + wch2;
                }
                szRet += String.fromCharCode(wch);
            } else {
                szRet += szInput.charAt(x);
            }
        }
        return(szRet);
    }
    import getDate from "../common/dataFormat.js";
    export default {

        data() {
            return { pickerOptions: {
                    shortcuts: [{
                        text: '本周',
                        onClick(picker) {
                            const end = getDate.getCurrWeekDays().endtime;
                            const start = getDate.getCurrWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上周',
                        onClick(picker) {
                            const end = getDate.getLastWeekDays().endtime;
                            const start = getDate.getLastWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            const end = getDate.getCurrMonthDays().endtime;
                            const start = getDate.getCurrMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            const end = getDate.getLastMonthDays().endtime;
                            const start = getDate.getLastMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                formData: "",
                form: {
                    realName: '',
                    id: '',
                    remitStipulate: '',
                    topNickName:'',
                    remake: ''
                },
                downloadVisible: false,
                disabledVisible: false,
                editVisible: false,
                date: '',
                pageNum: 1,
                pageSize: 10,
                total: 1,
                tableData: [],
                query: {
                    nickName: '',
                    realName: '',
                    startTime: '',
                    endTime: ''
                }, authorization: localStorage.getItem('authorization'),
                fileName: {
                    'content-type': ''
                }
            }

        },
        created() {
            this.date = [
                getDate.getCurrWeekDays().starttime, getDate.getCurrWeekDays().endtime
            ]
            this.query.startTime = getDate.getCurrWeekDays().starttime;
            this.query.endTime = getDate.getCurrWeekDays().endtime;
            this.getData()
        },
        methods: {
            excelExport(){
                this.axios.get('/api-b/10041/100189',{
                    headers:{
                        Authorization: this.authorization
                    }, responseType: "blob"
                }).then(response => {
                    const BLOB = response.data;
                    const headers = response.headers
                    this.fileName = JSON.parse(JSON.stringify(headers));
                    let arr = this.fileName["content-type"].split(";");
                    this.fileName = arr[1];
                    let ar = this.fileName.split("=");
                    this.fileName = ar[1];
                    // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                    const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                    fileReader.readAsDataURL(BLOB);
                    // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                    fileReader.onload = (event) => {
                        // 处理load事件。该事件在读取操作完成时触发
                        // 新建个下载的a标签，完成后移除。
                        let a = document.createElement("a");
                        a.download = revertUTF8(this.fileName);
                        a.href = event.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }

                })
            },
            download() {
                this.downloadVisible = true;
                this.axios.get("/api-b/10041/100190/?realName="
                    + this.query.realName + "&nickName=" + this.query.nickName + "&startTime=" + this.query.startTime + "&endTime=" + this.query.endTime, {
                    headers: {
                        Authorization: this.authorization,

                    }, responseType: "blob"
                }).then((response) => {
                        const BLOB = response.data;
                        const headers = response.headers
                        this.fileName = JSON.parse(JSON.stringify(headers));
                        let arr = this.fileName["content-type"].split(";");
                        this.fileName = arr[1];
                        let ar = this.fileName.split("=");
                        this.fileName = ar[1];
                        // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
                        const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                        fileReader.readAsDataURL(BLOB);
                        // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                        fileReader.onload = (event) => {
                            // 处理load事件。该事件在读取操作完成时触发
                            // 新建个下载的a标签，完成后移除。
                            let a = document.createElement("a");
                            a.download = revertUTF8(this.fileName);
                            a.href = event.target.result;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        };
                        this.downloadVisible = false;
                    }
                )
            },
            dateChange(val) {
                this.query.startTime = val[0]
                this.query.endTime = val[1]
                this.getData()
            },
            getData() {
                this.disabledVisible = true;
                this.axios.post("/api-b/10041/100195/" + this.pageNum + "/" + this.pageSize, this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    let data = res.data.data;
                    this.tableData = data.list;
                    this.pageNum = data.pageNum;
                    this.total = data.total;
                    this.$message.success(res.msg)
                    this.disabledVisible = false;
                }).catch(res =>{
                    console.log(res)
                })
            },
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            }, update(data) {
                this.editVisible = true;
                this.form.realName = data.realName;
                this.form.id = data.id;
                this.form.remitStipulate = data.remitStipulate;
                this.form.remake = data.remake;
                this.form.topNickName = data.list[0].topNickName;
            }, confirmEdit() {
                this.editVisible = false;
                this.axios.post("/api-b/10041/100194/",this.form, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code == 10000) {
                        this.$message.success(res.data.message)
                        this.methods.getData()
                    }
                }).catch(res =>{
                    console.log(res)
                    this.$message.success(res.data.message)
                })
            },uploadFile(item){
                let params = new FormData()
                params.append('file',item.file)
                this.axios.post("/api-b/10041/100193/",params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code == 10000) {
                        this.$message.success(res.data.message)
                        this.methods.getData()
                    }
                }).catch(res =>{
                    console.log(res)
                })
            }
            }




    }
</script>

<style>
    :focus {
        outline: none;
    }

    .el-drawer__header > :first-child {
        margin-top: -20px;
    }
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-upload{
        border: none!important;
    }
    .el-upload--text {
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height:36px;
        margin-top: -25px;
        font-size: 14px
    }
    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: center
    }
    .active{
        box-shadow: 0 2px 0 rgba(97,167,255,1);
        color:rgba(97,167,255,1);
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
</style>
